
function EmailTextareaCtrl(TranslationService) {
    var ctrl = this;

    ctrl.fontWeight = 'normal';

    this.$onChanges = function () {
        if (this.bold) {
            ctrl.fontWeight = 'bold';
        }
    };

    this.edit = function () {
        if (ctrl.readOnly) {
            return;
        }
        this.editing = !this.editing;
        if (this.editing) {
            ctrl.oldValue = ctrl.ngModel;
        }
    }

    this.discard = function () {
        //if (ctrl.oldValue) {
            ctrl.ngModel = ctrl.oldValue;
        //}
        ctrl.editing = false;
    };

    this.close = function () {
        ctrl.errors = [];
    }

    ctrl.handleTab = function (e) {
        //console.log('handleTab', e);
        if (e.key == 'Tab') {
            e.preventDefault();
            var start = e.target.selectionStart;
            var end = e.target.selectionEnd;
            e.target.value = e.target.value.substring(0, start) + "\t" + e.target.value.substring(end);
            e.target.selectionStart = e.target.selectionEnd = start + 1;
        }
    };
}

EmailTextareaCtrl.$inject = ['TranslationService'];

seedWebApp.component('emailTextarea', {
    controller: EmailTextareaCtrl,
    controllerAs: 'ctrl',
    bindings: {
        label: '<',
        ngModel: '=',
        rows: '<',
        bold: '<',
        readOnly:'<',
    },
    templateUrl: '/SPA/logistics/email-textarea.html' + seedWebApp.buildVersion
});